import { ref } from 'vue';
import { useLocale } from './useLocale';

import { get } from '@/api/httpClient';
import type { BuildingFacade } from '@/typings/buildings/BuildingFacade';

export function useBuildingFacadesApi() {
  const getBuildingFacadesLoading = ref(false);
  const getBuildingFacadesError = ref<string | undefined>();
  const { getLocale } = useLocale();

  async function getBuildingFacades(buildingId: number): Promise<BuildingFacade[]> {
    getBuildingFacadesLoading.value = true;
    getBuildingFacadesError.value = undefined;

    try {
      const lang = getLocale();
      const response = await get<undefined, BuildingFacade[]>(`/buildings/${buildingId}/facades?locale=${lang}`);
      return response;
    } catch (error) {
      console.error('Error fetching building facades:', error);
      getBuildingFacadesError.value = error instanceof Error ? error.message : 'Unknown error';
      return [];
    } finally {
      getBuildingFacadesLoading.value = false;
    }
  }

  return {
    getBuildingFacades,
    getBuildingFacadesLoading,
    getBuildingFacadesError
  };
}